// The sealy two-column account-page shell shared by the login, registration
// and lookup-orders-by-email documents: the capped-width wrapper, the page
// heading, the form column (section heading + children), and the decorative
// account image column. `footer` renders inside the capped-width wrapper,
// after the split section.
import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import styles from "./index.module.scss";

type IProps = Immutable<{
    heading?: string | null;
    sectionHeading?: string | null;
}> & {
    children?: React.ReactNode;
    footer?: React.ReactNode;
};

export const AccountSplitShell = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="l-capped-width">
            <header>
                <h1>{props.heading}</h1>
            </header>

            <section className={styles.accountSplitShell}>
                <div>
                    <h2>{props.sectionHeading}</h2>
                    {props.children}
                </div>
                <div>
                    {/* Decorative image: empty alt attr */}
                    <img
                        src={`${staticURL}img/accounts/accounts-page-img.jpg`}
                        alt=""
                    />
                </div>
            </section>

            {props.footer}
        </div>
    );
};
